import React, { Fragment } from 'react';
import { Nav, NavItem, } from 'reactstrap';
import { Payment, Qpay, addRequest, addService, addserviceRequest, pay, serviceRequest } from '../../Constant';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';

const NavCustomizer = ({ callbackNav, selected }) => {
    const authState = useSelector(state => state.auth);
    const navigate = useNavigate();
    const handleNvaigate = () =>{
        navigate(`${process.env.PUBLIC_URL}/service-request-add`);
    }
    return (
        <Fragment>           
            {/* <Nav className="flex-column nac-pills" id="c-pills-tab" role="tablist" aria-orientation="vertical"> */}
                {/* <NavItem> */}
                {/* <NavLink className={selected === 'color-picker' ? 'active' : ''} onClick={() => callbackNav('color-picker', true)}> */}

                    <button style={{ backgroundColor: '#007bff', color: '#fff',border:'none',padding:'14px',borderRadius:'12px' }} className='bg-primary text-white '  onClick={() => handleNvaigate()}>
                        <div className="settings "><i className="text-center">
                        <div className='qpay-rightbar pt-1 fw-bold'>
                       <b> {addRequest}</b>
                            </div>
                          </i> </div>
                    </button>
                {/* </NavItem> */}
                {/* <NavItem> */}
                    {/* <NavLink className={selected === 'sidebar-type' ? 'active' : ''} onClick={() => callbackNav('sidebar-type', true)}>
                        <div className="settings"><i className="icon-settings"></i></div>
                    </NavLink> */}
                {/* </NavItem> */}
            {/* </Nav> */}
        </Fragment>
    );
};

export default NavCustomizer;